import { ActionReducerMap, createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCore from './core.reducer';
import * as fromRouter from '@ngrx/router-store';
import { BaseRouterStoreState } from '@ngrx/router-store';

export interface State {
  core: fromCore.State;
  router: fromRouter.RouterReducerState<BaseRouterStoreState>;
}

export const reducers: ActionReducerMap<State> = {
  core: fromCore.reducer,
  router: fromRouter.routerReducer,
};

export const selectCore = createFeatureSelector<fromCore.State>(fromCore.featureName);
export const selectCoreState = createSelector(selectCore, (state) => state);

export const selectNetwork = createSelector(selectCoreState, ({ online }) => ({ online }));
export const selectDebug = createSelector(selectCoreState, ({ isDebug }) => isDebug);
